import { API_ENDPOINTS, createApiUrl, ServiceType } from 'src/contstant/apiEndpoints';
import { apiClient } from '../apiClient';
import {
  CreateDivisionRequest,
  CreateDivisionResponse,
  DeleteDivisionRequest,
  DeleteDivisionResponse,
  ListDivisionsRequest,
  ListDivisionsResponse,
  UpdateDivisonRequest,
  UpdateDivisonResponse,
} from 'src/types/orbit/Division';

export const divisionService = {
  getAllByBusinessUnit: (data: ListDivisionsRequest) => {
    return apiClient.get<ListDivisionsResponse>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.DIVISIONS.ALL(data.programId, data.businessUnitId),
      ),
      data,
    );
  },

  create: (data: CreateDivisionRequest) => {
    return apiClient.post<CreateDivisionResponse, CreateDivisionRequest>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.DIVISIONS.CREATE(data.programId, data.businessUnit),
      ),
      data,
    );
  },

  update: (data: UpdateDivisonRequest) => {
    return apiClient.put<UpdateDivisonResponse, UpdateDivisonRequest>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.DIVISIONS.UPDATE(
          data.programId,
          data.businessUnit,
          data.divisionName,
        ),
      ),
      data,
    );
  },

  delete: (data: DeleteDivisionRequest) => {
    return apiClient.delete<DeleteDivisionResponse>(
      ServiceType.ORBIT,
      createApiUrl(
        API_ENDPOINTS.ORBIT_SERVERICE.DIVISIONS.DELETE(
          data.programId,
          data.businessUnit,
          data.divisionName,
        ),
      ),
      data,
      data.deletedBy,
    );
  },
};
